let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ctZCD"), load("7tbBL")]).then(() => parcelRequire('ihnIJ'));